import { useEffect } from "react";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

const Analytics = () => {
  useEffect(() => {
    const handleKnownBrowserNoise = (event) => {
      if (
        event.error instanceof DOMException &&
        event.error.name === "DataCloneError" &&
        event.message?.includes("PerformanceServerTiming")
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    };

    window.addEventListener("error", handleKnownBrowserNoise, true);

    if (!POSTHOG_KEY || window.posthog) {
      return () => window.removeEventListener("error", handleKnownBrowserNoise, true);
    }

    window.posthog = window.posthog || [];
    window.posthog._i = window.posthog._i || [];
    window.posthog.init = function init(key, config, name) {
      const target = name ? (window.posthog[name] = []) : window.posthog;
      const methods = ["capture", "identify", "reset", "set_config"];

      methods.forEach((method) => {
        target[method] = function proxyMethod(...args) {
          target.push([method, ...args]);
        };
      });

      window.posthog._i.push([key, config, name]);
    };

    window.posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: "identified_only",
      session_recording: {
        recordCrossOriginIframes: false,
        capturePerformance: false,
      },
    });

    const script = document.createElement("script");
    script.src = `${POSTHOG_HOST.replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.dataset.analytics = "posthog";
    document.head.appendChild(script);

    return () => {
      window.removeEventListener("error", handleKnownBrowserNoise, true);
      script.remove();
    };
  }, []);

  return null;
};

export default Analytics;
